// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"96e63b6cd88145d6c54d","655":"16c24cd9b6f5e59291e1"}[chunkId] + ".js";
};